// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z0Sy","footer":"styles_footer__1HrBf"};